export function LandingChipSectionHeader({
  label,
  wrapperClassName = "",
  chipClassName = "",
}: {
  label: string
  /** Extra classes applied to the outer flex wrapper */
  wrapperClassName?: string
  /** Extra classes applied to the inner chip wrapper (where margin utilities often live) */
  chipClassName?: string
}) {
  return (
    <div className={`flex justify-center mb-[0.62rem] ${wrapperClassName}`.trim()}>
      <div className={`relative inline-block ${chipClassName}`.trim()}>
        {/* Chip label */}
        <div
          className={`relative z-10 px-4 py-1.5 ${label.includes("\n") ? "whitespace-pre-line text-center" : "whitespace-nowrap"}`}
        >
          <span className="text-[#0074FF] text-sm font-semibold tracking-wide">{label}</span>
        </div>
        {/* Skewed background with gradient border (mask technique for proper rounded corners) */}
        <div
          className="absolute inset-0  opacity-75 transform skew-x-[-16deg] rounded-md pointer-events-none"
          style={{
            padding: "0.1rem",
            background: "linear-gradient(to right, #0074FF, #22FF65A6)",
            WebkitMask: "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
            WebkitMaskComposite: "xor",
            maskComposite: "exclude",
          }}
        />
        {/* Top-edge highlight: fades from #40b580 at centre to transparent at edges */}
        <div
          className="absolute opacity-75 top-0 left-0 right-0 h-[2px] transform skew-x-[-16deg] rounded-t-md pointer-events-none edge-gradient-animate"
          style={{
            background: "linear-gradient(90deg, transparent 0%, #0074FF 50%, transparent 100%)",
          }}
        />
      </div>
    </div>
  )
}
